module.exports = __webpack_public_path__ + "img/squiggle.d1366003.svg";